
<template>
  <div class="mt-3">
    <v-card style="border-radius:12px" outlined>
      <v-card-title primary-title class="py-2 grey lighten-2">
        <div class="headline mb-0">Pagamento {{idx}}</div>
        <v-spacer></v-spacer>
        <v-btn v-if="idx > 1" icon color="error" @click="emitDelete()"><v-icon>mdi-delete</v-icon></v-btn>
      </v-card-title>
      <v-card-text class="pa-5 pt-2">
          <v-autocomplete
            v-model="one_payment.payment_option_id"
            :items="filtered_options"
            label="Modo de pagamento"
            hide-no-data
            item-text="attributes.display_name"
            item-value="id"
            prepend-icon="mdi-information"
            :rules="required"
            :loading="filtered_options.length == 0"
          >
            <v-slide-x-reverse-transition slot="append-outer" mode="out-in"></v-slide-x-reverse-transition>
          </v-autocomplete>
          <v-autocomplete
            v-model="one_payment.payment_time_id"
            :items="filtered_times"
            label="Prazo para pagamento"
            hide-no-data
            item-text="attributes.description"
            item-value="id"
            prepend-icon="mdi-calendar"
            :rules="required"
            :loading="filtered_times.length == 0"
          >
            <v-slide-x-reverse-transition slot="append-outer" mode="out-in"></v-slide-x-reverse-transition>
          </v-autocomplete>
          <v-text-field v-model="one_payment.ammount" v-currency="currency" :rules="not_zero" prepend-icon="mdi-currency-brl" label="Valor"></v-text-field>

        <template v-if="new_order?.is_default_client && is_deposit">
          <with-deposit :with_doc='false' @doneDoc="handleDoneDoc" @removeDoc="handleRemoveDoc" :payment="one_payment.new_payment"></with-deposit>

          <v-alert type="error" v-if="not_same_ammount">
            Atenção! Valor do depósito deve ser igual ao da parcela!
          </v-alert>
        </template>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import {CurrencyDirective} from 'vue-currency-input'
import validations from '@/mixins/validations'

export default {
  name: 'PaymentSelection',
  components: {
    WithDeposit: ()=> import('@/_backoffice/_financial/components/order_payment/WithDeposit.vue'),
  },
  props: {
    idx: {
      type: Number,
      default: 1
    },
    one_payment: {
      type: Object,
      default: {}
    },
    payment_times:{
      type: Array,
    },
    payment_options:{
      type: Array,
    },
    wholesale:{
      type: Boolean,
      default: false,
    },
    order:{
      type: [Object],
    },
  },
  mixins: [validations],
  directives: {
    currency: CurrencyDirective,
  },
  data() {
    return {
      key: null,
      currency:{
        currency: null,
        locale: 'en-EN',
        autoDecimalMode: true,
        decimalLength: 2,
        distractionFree:false,
      },
      new_payment: {
        deposit_details: {
          has_entrance: false,
          entrance_value_aux: '0.00',
          has_one_day: false,
          one_day_value_aux: '0.00',
          has_two_days: false,
          two_days_value_aux: '0.00',
          deposit_date: null,
          deposit_bank: null,
          deposit_company: null,

          document: null,
        },
      },
    }
  },
  methods: {
    handleDoneDoc(e) {
      this.new_payment = {
        ...this.new_payment,
        deposit_details: {
          ...this.new_payment.deposit_details,
          document: {...e}
        }
      }
    },
    handleRemoveDoc(){
      this.new_payment = {
        ...this.new_payment,
        deposit_details: {
          ...this.new_payment.deposit_details,
          document: {}
        }
      }
    },
    emitDelete(){
      this.$emit('delete', (this.idx-1))
    },
  },
  computed: {
    client_without_limit(){
      return this.order?.client?.credits?.data?.attributes?.status_id == 10 || this.order?.client?.client_credit?.status_id == 10
    },
    not_same_ammount() {
      if (this.is_deposit && this.new_order?.is_default_client){
        let {has_entrance, entrance_value_aux, has_one_day, one_day_value_aux, has_two_days, two_days_value_aux} = this.one_payment.new_payment.deposit_details
        let entrance = has_entrance? Number(entrance_value_aux.toString().replace(/,/g, '')) : 0
        let one_day = has_one_day? Number(one_day_value_aux.toString().replace(/,/g, '')) : 0
        let two_days = has_two_days? Number(two_days_value_aux.toString().replace(/,/g, '')) : 0
        let total = entrance + one_day + two_days
        return Number(this.one_payment.ammount.replace(/,/g, '')) != total
      }
      return false
    },
    computed_order(){
      return this.order || ( this.one_order?.id ? this.one_order : this.new_order )
    },
    filtered_options() {
      let is_default_client_or_new = this.computed_order?.is_default_client || (this.one_order?.client && this.one_order?.client.name && this.one_order?.client.name.toUpperCase().includes('CLIENTE FINAL')) || this.client_without_limit 
      if (is_default_client_or_new){
        let locked = ['DEPÓSITO', 'BOLETO', 'CHEQUE', 'TRANSFERÊNCIA', 'PERMUTA', 'NOTA PROMISSÓRIA']
        return this.payment_options.filter(opt => !locked.includes(opt.attributes.description.toUpperCase()))
      }
      
      // Verificar se o cliente tem restrições de formas de pagamento
      let client = this.computed_order?.client
      if (client && client.allowed_payment_option_ids && client.allowed_payment_option_ids.length > 0) {
        return this.payment_options.filter(opt => 
          client.allowed_payment_option_ids.includes(parseInt(opt.id))
        )
      }
      
      return this.payment_options
    },
    filtered_times() {
      let is_default_client_or_new = this.computed_order?.is_default_client || (this.one_order?.client && this.one_order?.client.name && this.one_order?.client.name.toUpperCase().includes('CLIENTE FINAL')) || this.client_without_limit 
      if (is_default_client_or_new){
        return this.payment_times.filter(opt => opt.attributes.description.toLowerCase().includes('vista'))
      } else if (this.is_pix || [1, 6].includes(this.one_payment.payment_option_id)){ // pix e dinheiro
        return this.payment_times.filter(opt => opt.attributes.description.toLowerCase().includes('vista'))
      }
      
      // Verificar se o cliente tem restrições de prazos de pagamento
      let client = this.computed_order?.client
      if (client && client.allowed_payment_time_ids && client.allowed_payment_time_ids.length > 0) {
        return this.payment_times.filter(time => 
          client.allowed_payment_time_ids.includes(parseInt(time.id))
        )
      }
      
      return this.payment_times
    },
    is_deposit(){
      let str = "DEPÓSITO"
      let dep_id = this.payment_options.find(o=> o.attributes.description.toUpperCase().trim() == str).id
      if (dep_id && this.one_payment.payment_option_id){
        return this.one_payment.payment_option_id == dep_id
      }
      return false
    },
    is_pix(){
      let str = "PIX"
      if (this.one_payment.payment_option_id && this.payment_options.length){
        let pix = this.payment_options.find(o=> o.id == this.one_payment.payment_option_id).attributes.description
        return pix && str.toUpperCase() == pix.toUpperCase()
      }
      return false
    },
    is_entrance(){
      if (this.one_payment.payment_time_id && this.payment_times){
        let ent = this.payment_times.find(opt => opt.attributes.description.toLowerCase().includes('vista'))
        return ent && this.one_payment.payment_time_id == ent.id
      }
      return false
    },
    time_due_date_in_days() {
      if (this.one_payment.payment_time_id && this.payment_times.length){
        return this.payment_times.find(opt => opt.id == this.one_payment.payment_time_id).attributes.daysBase
      }
      return null
    },
    ...mapState({
      new_order: state => state.NewOrder?.new_order,
      one_order: state => state.Order?.oneOrder,
    })
  },
  watch: {
    is_pix(nv,ov) {
      if (nv){
    
      } else if (nv == false){
        this.one_payment.pix_data = null
      }
    },
    'one_payment.payment_option_id'(nv,ov) {
      if (nv){
        if (!this.is_deposit){
          this.one_payment.new_payment = null
          this.new_payment = {
            deposit_details: {
              has_entrance: false,
              entrance_value_aux: '0.00',
              has_one_day: false,
              one_day_value_aux: '0.00',
              has_two_days: false,
              two_days_value_aux: '0.00',
              deposit_date: null,
              deposit_bank: null,
              deposit_company: null,

              document: null,
            }
          }
        } else {
          if (this.new_order?.is_default_client){
            this.one_payment.new_payment = {...this.new_payment}
          }
        }
      }
    }
  },
}
</script>
